var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_137",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#E86046"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 17.3333C17.5556 17.3333 16.6112 16.9444 15.8334 16.1666C15.0556 15.3889 14.6667 14.4444 14.6667 13.3333C14.6667 12.2222 15.0556 11.2778 15.8334 10.5C16.6112 9.7222 17.5556 9.33331 18.6667 9.33331C19.7778 9.33331 20.7223 9.7222 21.5 10.5C22.2778 11.2778 22.6667 12.2222 22.6667 13.3333C22.6667 14.4444 22.2778 15.3889 21.5 16.1666C20.7223 16.9444 19.7778 17.3333 18.6667 17.3333ZM9.33337 21.3333C8.60004 21.3333 7.97226 21.0722 7.45004 20.55C6.92782 20.0278 6.66671 19.4 6.66671 18.6666V7.99998C6.66671 7.26665 6.92782 6.63887 7.45004 6.11665C7.97226 5.59442 8.60004 5.33331 9.33337 5.33331H28C28.7334 5.33331 29.3612 5.59442 29.8834 6.11665C30.4056 6.63887 30.6667 7.26665 30.6667 7.99998V18.6666C30.6667 19.4 30.4056 20.0278 29.8834 20.55C29.3612 21.0722 28.7334 21.3333 28 21.3333H9.33337ZM12 18.6666H25.3334C25.3334 17.9333 25.5945 17.3055 26.1167 16.7833C26.6389 16.2611 27.2667 16 28 16V10.6666C27.2667 10.6666 26.6389 10.4055 26.1167 9.88331C25.5945 9.36109 25.3334 8.73331 25.3334 7.99998H12C12 8.73331 11.7389 9.36109 11.2167 9.88331C10.6945 10.4055 10.0667 10.6666 9.33337 10.6666V16C10.0667 16 10.6945 16.2611 11.2167 16.7833C11.7389 17.3055 12 17.9333 12 18.6666ZM26.6667 26.6666H4.00004C3.26671 26.6666 2.63893 26.4055 2.11671 25.8833C1.59449 25.3611 1.33337 24.7333 1.33337 24V9.33331H4.00004V24H26.6667V26.6666Z",
    fill: "#FB2648"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashIcon);
export default __webpack_public_path__ + "static/media/cash-icon.b1aeff6cee6c11120a2848f0121a6836.svg";
export { ForwardRef as ReactComponent };